module.exports = __webpack_public_path__ + "static/media/Article3.035fa0ab.webp";